module.exports = __webpack_public_path__ + "assets/ojo_bemakoha.241f69237860040beec72c032074601a.png";


//////////////////
// WEBPACK FOOTER
// ./img/ojo_bemakoha.png
// module id = 590
// module chunks = 0